<template>
  <div>
    <div class="materials">
      <v-category-button v-for='material in materials'
        @click="setQuestionDescription(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedQuestionDescription == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

  data: () => ({
    materials: [
      {id: 1, text: 'あり', type: 'have_description', disabled: false},
      {id: 2, text: 'なし', type: 'no_description', disabled: false},
    ]
  }),

  computed: {
    selectedQuestionDescription() {
      return this.$store.state.conditions.selectedQuestionDescription;
    }
  },

  mounted() {
  },

  methods: {
    setQuestionDescription(id) {
      this.$store.commit('conditions/setSelectedQuestionDescription', {
        id: id
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

</style>
